<template>
  <div class="BaseAnnexView">
    <el-dialog :title="$lang('查看附件')" :modal-append-to-body="false" :close-on-click-modal="false" :visible="visible" width="700px" @close="closeDialog">
      <div style="color: #F56C6C;font-size: 12px;">{{ $lang('*点击图片预览或下载附件') }}</div>
      <div class="img_box">
        <div class="img_size" v-for="(item, index) of list2" :key="index" v-show="list2.length !== 0">
          <img v-if="item.type === 'hidden'" :src="item.downloadUrl" />
          <span class="is-list" v-if="item.type !== 'hidden' && item.type !== 'video'">
            <i :class="'iconfont icon_size ' + item.type"></i>
          </span>
          <span class="is-list" v-if="item.type === 'video'">
            <video style="width: 120px; height: 120px; position: absolute; left: 0; top: 0" :controls="true" :key="item.downloadUrl" :src="item.downloadUrl"></video>
          </span>
          <div class="img-mark" v-if="item.type !== 'video'">
            <span v-if="item.type === 'hidden'" @click="showImg(item.downloadUrl)">
              <i class="el-icon-zoom-in"></i>
            </span>
            <span v-if="item.type !== 'hidden'" @click="handleDownload(item.downloadUrl)">
              <i class="iconfont iconcaozuopingtaitubiao_daojiancaozuo"></i>
            </span>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'BaseAnnexView',
  data() {
    return {
      list2: [],
      imgList: []
    }
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    // 数据
    fileListResAll: {
      type: Array,
      default: () => []
    }
  },
  watch: {
    fileListResAll: {
      deep: true,
      handler(newVal) {
        console.log(newVal, '33333333333');
        this.list2 = []
        newVal.forEach((item) => {
          this.list2.push({
            downloadUrl: item,
            type: this.getFileType(item)
          })
        })
        console.log(this.list2)
      }
    }
  },
  created() {},
  mounted() {},
  methods: {
    closeDialog() {
      this.$emit('update:visible', false)
    },
    // 图片预览
    showImg(data) {
      const imgList = []
      this.list2.forEach((item) => {
        if (item.type === 'hidden') {
          imgList.push(item.downloadUrl)
        }
      })
      console.log(imgList)
      const index = imgList.findIndex((item) => item === data)
      this.$openImagePreview(imgList, index)
    },
    // 文件下载
    handleDownload(file) {
      window.open(file)
    },
    /**
     * 判断文件类型ICON
     * @param {*} item 行数据
     */
    getFileType(data) {
      const name = data.toLowerCase()
      if (name.indexOf('.pdf') > -1) {
        return 'iconPDF'
      }
      if (name.indexOf('.docx') > -1) {
        return 'icondocx1'
      }
      if (name.indexOf('.doc') > -1) {
        return 'icondoc1'
      }
      if (name.indexOf('.xls') > -1) {
        return 'icongonggaoguanli-wendang'
      }
      if (name.indexOf('.zip') > -1) {
        return 'iconyasuobao'
      }
      if (name.indexOf('.mp4') > -1) {
        return 'video'
      }
      if (name.indexOf('.webm') > -1) {
        return 'video'
      }
      if (name.indexOf('.ogg') > -1) {
        return 'video'
      }
      if (name.indexOf('.mkv') > -1) {
        return 'video'
      }
      if (name.indexOf('.mp3') > -1) {
        return 'video'
      }
      if (name.indexOf('.rar') > -1) {
        return 'iconRAR'
      }
      return 'hidden'
    }
  }
}
</script>

<style lang="scss" scoped>
video::-webkit-media-controls.audio-only {
  background: rgba(0, 0, 0, 0.5);
  top: 0;
  border-radius: 0;
  display: none;
}
video::-webkit-media-controls-panel {
  // height: 100px;
  background: rgba(0, 0, 0, 0.3);
}
video::-webkit-media-controls-enclosure {
  max-height: 120px;
  border-radius: 0;
}
.img_size video::-webkit-media-controls-timeline {
  padding: 0;
}
.img_box {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  // padding-bottom: 20px;
  .img_size {
    position: relative;
    width: 120px;
    height: 120px;
    border: 1px solid #ddd;
    border-radius: 5px;
    margin: 15px 6px;
    box-sizing: border-box;
    display: flex;
    text-align: center;
    align-items: center;
    flex-wrap: wrap;
    @include border-color('light');
    .is-text {
      font-size: 12px;
      text-align: center;
      width: 100%;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    &:hover {
      .img-mark {
        span {
          display: block;
          width: 100%;
        }
        visibility: visible !important;
      }
    }
    .is-list {
      width: 120px;
      height: 120px;
      display: flex;
      align-items: center;
      justify-content: center;
      // position: relative;
    }
    .img-mark {
      position: absolute;
      visibility: hidden;
      width: 120px;
      height: 28px;
      bottom: 0;
      left: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      background: rgba(0, 0, 0, 0.5);
      cursor: pointer;
      color: #ffffff;
    }
    img {
      width: 100%;
      height: 100%;
    }
  }
  .icon_size {
    font-size: 30px;
    @include base-color('clr');
  }
}
</style>
